import axios from "../lib/axios";
import { STORAGE_KEY } from "./state";
import { STORAGE_KEY_ACHIEVEMENTS } from "./modules/achievements/state";
import { STORAGE_KEY_CHARACTERS } from "./modules/characters/state";
import { STORAGE_KEY_PAGES } from "./modules/pages/state";
import { STORAGE_KEY_ITEMS } from "./modules/items/state";
import { STORAGE_KEY_RULES } from "./modules/rules/state";
import { STORAGE_KEY_SPELLS } from "./modules/spells/state";

export const signIn = async ({ commit, state }, payload) => {
  try {
    commit("SIGNIN", payload);
    // GET USER PROFILE
    let res = await axios.get(`/sign-in/profile`, {
      headers: { Authorization: `Bearer ${state.session.accessToken}` }
    });
    commit("SET_USER", res.data);
    return;
  } catch (err) {
    commit("ALERT", {
      type: "sign-in",
      title: "Error",
      message: "Unable to Sign In at this time. Please try again later."
    });
    commit("SIGNOUT");
    throw new Error(err);
  }
};

export const updateProfile = async ({ commit, state }) => {
  try {
    let res = await axios.get(`/sign-in/profile`, {
      headers: { Authorization: `Bearer ${state.session.accessToken}` }
    });
    commit("SET_USER", res.data);
    return;
  } catch (err) {
    throw new Error("Unable to update profile");
  }
};

export const setRuleset = async ({ commit }, payload) => {
  try {
    // SET RULESET
    let res = await axios.patch(`/ruleset`, payload);
    commit("SET_USER", res.data);
    return;
  } catch (err) {
    throw new Error(err);
  }
};

export const updateSettings = async ({ commit }, payload) => {
  try {
    // UPDATE SETTINGS
    let res = await axios.patch(`/updateSettings`, { settings: payload });
    commit("SET_USER", res.data);
    return;
  } catch (err) {
    throw new Error(err);
  }
};

export const signOut = ({ commit }) => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_KEY_ACHIEVEMENTS);
  localStorage.removeItem(STORAGE_KEY_CHARACTERS);
  localStorage.removeItem(STORAGE_KEY_PAGES);
  localStorage.removeItem(STORAGE_KEY_ITEMS);
  localStorage.removeItem(STORAGE_KEY_RULES);
  localStorage.removeItem(STORAGE_KEY_SPELLS);
  commit("SIGNOUT");
};

// used by router
export const isAuthorized = ({ state }, payload) => {
  return payload.role && state.session.user && state.session.user.roles
    ? state.session.user.roles.includes(payload.role)
    : false;
};

export const bearerToken = state => {
  return `Bearer ${state.session.accessToken}`;
};
